<template>
  <div class="calc-points-list">
    <div class="calc-points-list__search-wrap calculator-field">
      <div class="field-input">
        <input
          :value="searchText"
          class="field-input__inner form__input"
          placeholder="Поиск отделения"
          type="text"
          @input="onChangeSearchText"
        >
        <svg
          width="24px"
          height="24px"
        >
          <use xlink:href="#search3" />
        </svg>
      </div>
    </div>

    <div
      ref="listItems"
      class="calc-points-list__items"
    >
      <div
        v-if="selectOdpShow"
        class="calc-radio-wrap"
      >
        <div
          class="calc-radio-btn active"
        >
          <svg
            class="calc-radio-btn__icon"
            width="24px"
            height="24px"
          >
            <use xlink:href="#select-on" />
          </svg>
          <div>
            <div
              class="calc-radio-btn__name"
            >
              <svg
                width="16px"
                height="16px"
              >
                <use xlink:href="#point" />
              </svg>
              {{ selectOdpShow.address }}
            </div>
            <div
              v-if="selectOdpShow.phone"
              class="calc-radio-btn__size">
              <svg
                width="16px"
                height="16px"
              >
                <use xlink:href="#tel" />
              </svg>
              {{ selectOdpShow.phone }}
            </div>

            <div
              v-if="selectOdpShow.scheduleShort"
              class="calc-radio-btn__desc"
            >
              <svg
                width="16px"
                height="16px"
              >
                <use xlink:href="#clock2" />
              </svg>
              {{ selectOdpShow.scheduleShort }}
            </div>
          </div>
        </div>
      </div>
      <template
        v-if="odpFilter && odpFilter.length"
      >
        <div
          v-for="odpItem in odpFilter"
          :key="odpItem.id"
          class="calc-radio-wrap"
          @click="() => onClick(odpItem)"
        >
          <div
            class="calc-radio-btn"
          >
            <svg
              class="calc-radio-btn__icon"
              width="24px"
              height="24px"
            >
              <use xlink:href="#select-off" />
            </svg>
            <div>
              <div
                class="calc-radio-btn__name"
              >
                <div class="calc-radio-btn__svg-wrap">
                  <svg
                    width="16px"
                    height="16px"
                  >
                    <use xlink:href="#point" />
                  </svg>
                </div>
                {{ odpItem.address }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'CalcPointsList',
  props: {
    odp: [Object, Array],
    ODPPreview: Object,
  },
  data: () => ({
    searchText: '',
    selectOdp: '',
  }),
  computed: {
    odpFilter() {
      let { odp } = this;
      if (!odp) return [];
      if (this.ODPPreview && this.ODPPreview.id) {
        odp = odp.filter((item) => item.id !== this.ODPPreview.id);
      }
      if (this.selectOdp) {
        odp = odp.filter((item) => item.id !== this.selectOdp.id);
      }
      if (!this.searchText) return odp;
      return odp.filter((odpItem) => odpItem.address && odpItem.address.toLowerCase().includes(this.searchText.toLowerCase()));
    },
    selectOdpShow() {
      if (this.selectOdp) return this.selectOdp;
      if (this.ODPPreview && Object.keys(this.ODPPreview).length) return this.ODPPreview;
      return false;
    },
  },
  watch: {
    ODPPreview: {
      handler(val) {
        if (val) {
          this.scrollToTop();
          this.onCheckOdp(val);
          this.selectOdp = '';
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.debouncedChangeSearchText = _.debounce(this.changeSearchText, 300);
  },
  methods: {
    onChangeSearchText($event) {
      this.debouncedChangeSearchText($event.target.value?.trim());
    },
    changeSearchText(value) {
      this.searchText = value;
    },
    scrollToTop() {
      if (!this.$refs.listItems) return;
      this.$refs.listItems.scrollTop = 0;
    },
    onCheckOdp(odp) {
      this.$emit('checkPoint', odp);
    },
    onClick(odpItem) {
      this.scrollToTop();
      this.selectOdp = odpItem;
      this.$emit('selectOdp', odpItem);
    },
  },
};
</script>

<style lang="scss" scoped>
.calc-points-list {
  height: 439px;
  display: flex;
  flex-direction: column;
}
.calc-points-list__items {
  list-style: none;
  padding: 0;
  margin: 0;
  flex-grow: 1;
  overflow: auto;
}
.calc-points-list__search-wrap {
  margin-bottom: 12px;
  width: 100%;
  max-width: 100%;
  flex-basis: auto;
}
.calc-radio-btn {
  padding: 11px 16px 11px 48px !important;
  margin-bottom: 8px;
}
.calc-radio-btn__name {
  display: flex;
  align-items: center;
  min-height: 24px;
  margin-top: 0;
  margin-bottom: 0 !important;
  color: #50616F !important;
  svg {
    flex-shrink: 0;
    align-self: flex-start;
  }
}
.calc-radio-btn__svg-wrap {
  display: flex;
  align-items: center;
  height: 24px;
  margin-right: 8px;
}
.calc-points-list__items .calc-radio-btn__desc,
.calc-points-list__items .calc-radio-btn__size {
  display: flex;
  align-items: center;
  font-style: normal;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #50616F;

  svg {
    flex-shrink: 0;
    margin-right: 8px;
  }
}
.calc-radio-btn__desc,
.calc-radio-btn__size {
  margin: 8px 0 0 0 !important;

}
.calc-radio-wrap {
  margin-bottom: 8px !important;
}
</style>
